import React, { useEffect, useMemo, useState } from "react";
import "../../styles/common/navbar.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
// import userIcon from "../../assets/png/user.png";
// import userActiveIcon from "../../assets/png/userActive.png";
import EdluminaLogo from "../../assets/png/edlumina-logo-1.png";
import NavbarCollapseLogo from "../../assets/png/navabar-collapse-logo.png";
import {
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
  Factory,
  School,
  WorkspacePremium,
  BusinessCenter,
  AssignmentTurnedIn,
  AutoStories,
  Psychology,
  LibraryBooks,
  Groups,
  HowToReg,
  FactCheck,
  Assignment,
  Person,
  Inventory,
  Tune,
  Extension,
  Logout,
  EmojiEvents,
} from "@mui/icons-material";
import PsychologyAltIcon from "@mui/icons-material/PsychologyAlt";
import PreferencesIcon from "@mui/icons-material/ManageAccounts";
import CloseIcon from "@mui/icons-material/Close";
import Cookies from "js-cookie";
import TooltipText from "./tooltipText";
import DeleteConfirmPopUp from "./deleteConfirmPopUp";
import { ReactComponent as BlogIcon } from "../../assets/svg/blogicon.svg";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import QuizIcon from "@mui/icons-material/Quiz";
import VideoIcon from "@mui/icons-material/VideoCall";
import Image from "@mui/icons-material/Image";
import {
  superAdminLogout,
  institutionLogout,
} from "../../helper/apicalls/login";

const Navbar = ({
  collapsed: collapsedProp,
  onToggleCollapse,
  mobileMenuOpen,
  onToggleMobileMenu,
  setIsShowHeader,
}) => {
  const [internalMenuOpen, setInternalMenuOpen] = useState(false);
  const [activePage, setActivePage] = useState("");
  const [internalCollapsed, setInternalCollapsed] = useState(false);
  const [isConfirmLogoutOpen, setIsConfirmLogoutOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const role = Cookies.get("role");
  const permissions = Cookies.get("permissions");
  const permissionsData = permissions ? JSON.parse(permissions) : [];
  const currentPath = location.pathname;
  const portal = currentPath?.split("/")[1];

  const handleConfirmLogout = async () => {
    try {
      if (role === "admin") {
        try {
          await superAdminLogout();
        } catch (e) {}
      } else if (role === "institution" || role === "teacher") {
        try {
          await institutionLogout();
        } catch (e) {}
      }
    } finally {
      // Empty all cookies
      const keys = Object.keys(Cookies.get());
      keys.forEach((k) => {
        Cookies.remove(k);
        Cookies.remove(k, { path: "/" });
      });

      if (role === "admin") {
        navigate("/admin/login");
      } else {
        navigate("/");
      }

      setIsConfirmLogoutOpen(false);
    }
  };

  const handleLogout = () => {
    setIsConfirmLogoutOpen(true);
  };

  const viewTabPermission = (name) => {
    const status = permissionsData?.find((i) => i?.permission_type === name);
    return status?.read;
  };

  const iconColor = (active) =>
    active ? "var(--btn-primary-bg-color)" : "var(--secondary-text)";
  const iconSx = (active) => ({ fontSize: 13, color: iconColor(active) });

  const getIconByKey = (key, active) => {
    switch (key) {
      case "dashboard":
        return <DashboardOutlinedIcon sx={iconSx(active)} />;
      case "reports":
        return <DashboardOutlinedIcon sx={iconSx(active)} />;
      case "overall":
        return <QuizIcon sx={iconSx(active)} />;
      case "guides_materials":
        return <MenuBookIcon sx={iconSx(active)} />;
      case "videos":
        return <VideoIcon sx={iconSx(active)} />;
      case "blog":
        return (
          <BlogIcon style={{ ...iconSx(active), width: 15, height: 15 }} />
        );
      case "profile":
        return <Person sx={iconSx(active)} />;
      case "jobs":
        return <BusinessCenter sx={iconSx(active)} />;
      case "applied_jobs":
        return <AssignmentTurnedIn sx={iconSx(active)} />;
      case "enrolled_courses":
        return <LibraryBooks sx={iconSx(active)} />;
      case "lifecycle":
        return <Psychology sx={iconSx(active)} />;
      case "batches":
        return <Inventory sx={iconSx(active)} />;
      case "adminusers":
        return <Groups sx={iconSx(active)} />;
      case "applications":
        return <HowToReg sx={iconSx(active)} />;
      case "assesments":
        return <FactCheck sx={iconSx(active)} />;
      case "iq_test":
        return <Extension sx={iconSx(active)} />;
      case "courses":
      case "course-content":
        return <AutoStories sx={iconSx(active)} />;
      // case "eval":
      //   return <AutoStories sx={iconSx(active)} />;
      case "initial_test":
        return <PsychologyAltIcon sx={iconSx(active)} />;
      case "preference":
        return <PreferencesIcon sx={iconSx(active)} />;
      case "industryonboard":
        return <Factory sx={iconSx(active)} />;
      case "teachers":
        return <Person sx={iconSx(active)} />;
      case "students":
        return <Groups sx={iconSx(active)} />;
      case "materials":
        return <Assignment sx={iconSx(active)} />;
      case "question_banks":
        return <FactCheck sx={iconSx(active)} />;
      case "gamification":
        return <EmojiEvents sx={iconSx(active)} />;
      case "institutiononboard":
        return <School sx={iconSx(active)} />;
      case "assignment":
        return <Assignment sx={iconSx(active)} />;
      case "certificate":
        return <WorkspacePremium sx={iconSx(active)} />;
      case "question_bank":
        return <FactCheck sx={iconSx(active)} />;
      case "models":
        return <Tune sx={iconSx(active)} />;
      case "prompts":
        return <PsychologyAltIcon sx={iconSx(active)} />;
      case "image_upload":
        return <Image sx={iconSx(active)} />;
      case "logout":
        return <Logout sx={iconSx(active)} />;
      default:
        return <AutoStories sx={iconSx(active)} />;
    }
  };

  const navItems = useMemo(
    () =>
      role === "admin"
        ? [
            {
              id: 1,
              text: "Dashboard",
              key: "dashboard",
              path: "/admin/dashboard",
            },
            {
              id: 14,
              text: "Reports",
              key: "reports",
              path: "/admin/reports",
            },
            {
              id: 2,
              text: "Courses",
              key: "courses",
              path: "/admin/courses",
            },
            // {
            //   id: 13,
            //   text: "Eval",
            //   key: "eval",
            //   path: "/admin/eval",
            // },
            {
              id: 3,
              text: "Materials",
              key: "materials",
              path: "/admin/materials",
            },
            {
              id: 4,
              text: "Psychometric Tests",
              key: "initial_test",
              path: "/admin/initial-test",
            },
            {
              id: 8,
              text: "IQ Tests",
              key: "iq_test",
              path: "/admin/iq_test",
            },
            {
              id: 5,
              text: "Question Bank",
              key: "question_bank",
              path: "/admin/question-bank",
            },
            {
              id: 15,
              text: "Image Upload",
              key: "image_upload",
              path: "/admin/image-upload",
            },
            {
              id: 6,
              text: "Institution",
              key: "institution",
              path: "/admin/institution",
            },
            {
              id: 7,
              text: "Preference",
              key: "preference",
              path: "/admin/preference",
            },

            {
              id: 8,
              text: "Models",
              key: "models",
              path: "/admin/models",
            },
            {
              id: 9,
              text: "AI Configuration",
              key: "prompts",
              path: "/admin/ai-configuration",
            },
            {
              id: 10,
              text: "Gamification",
              key: "gamification",
              path: "/admin/gamification",
            },
            {
              id: 11,
              text: "Profile",
              key: "profile",
              path: "/admin/profile",
            },
          ]
        : role === "institution"
          ? [
              {
                id: 1,
                text: "Dashboard",
                key: "dashboard",
                path: "/institution/dashboard",
              },
              {
                id: 2,
                text: "Reports",
                key: "reports",
                path: "/institution/reports",
              },
              ...(viewTabPermission("course")
                ? [
                    {
                      id: 3,
                      text: "Courses",
                      key: "courses",
                      path: "/institution/courses",
                      // isNoShowHeader: true,
                    },
                  ]
                : []),
              ...(viewTabPermission("batches")
                ? [
                    {
                      id: 4,
                      text: "Batches",
                      key: "batches",
                      path: "/institution/batches",
                    },
                  ]
                : []),
              ...(viewTabPermission("teacher")
                ? [
                    {
                      id: 5,
                      text: "Teachers",
                      key: "teachers",
                      path: "/institution/teachers",
                    },
                  ]
                : []),
              ...(viewTabPermission("student")
                ? [
                    {
                      id: 6,
                      text: "Students",
                      key: "students",
                      path: "/institution/students",
                    },
                  ]
                : []),
              ...(viewTabPermission("questionbank")
                ? [
                    {
                      id: 7,
                      text: "Question Banks",
                      key: "question_banks",
                      path: "/institution/question_banks",
                    },
                  ]
                : []),
              ...(viewTabPermission("material")
                ? [
                    {
                      id: 8,
                      text: "Materials",
                      key: "materials",
                      path: "/institution/materials",
                    },
                  ]
                : []),
              // {
              //   id: 9,
              //   text: "Current Affairs",
              //   key: "blog",
              //   path: "/admin/blog",
              // },
              // {
              //   id: 10,
              //   text: "Tests",
              //   key: "overall",
              //   path: "/admin/overall",
              // },
              // {
              //   id: 11,
              //   text: "Guides & Materials",
              //   key: "guides_materials",
              //   path: "/admin/guides-materials",
              // },
              // {
              //   id: 12,
              //   text: "Videos",
              //   key: "videos",
              //   path: "/admin/videos",
              // },
              {
                id: 9,
                text: "Profile",
                key: "profile",
                path: "/institution/profile",
              },
            ]
          : role === "teacher"
            ? [
                {
                  id: 1,
                  text: "Dashboard",
                  key: "dashboard",
                  path: "/teacher/dashboard",
                },
                {
                  id: 9,
                  text: "Current Affairs",
                  key: "blog",
                  path: "/teacher/blog",
                },
                // {
                //   id: 10,
                //   text: "Tests",
                //   key: "overall",
                //   path: "/teacher/overall",
                // },
                {
                  id: 11,
                  text: "Guides & Materials",
                  key: "guides_materials",
                  path: "/teacher/guides-materials",
                },
                {
                  id: 12,
                  text: "Videos",
                  key: "videos",
                  path: "/teacher/videos",
                },
                ...(viewTabPermission("course")
                  ? [
                      {
                        id: 2,
                        text: "Courses",
                        key: "courses",
                        path: "/teacher/courses",
                        // isNoShowHeader: true,
                      },
                    ]
                  : []),
                ...(viewTabPermission("course")
                  ? [
                      {
                        id: 21,
                        text: "Course Content",
                        key: "course-content",
                        path: "/teacher/course-content",
                      },
                    ]
                  : []),
                ...(viewTabPermission("batches")
                  ? [
                      {
                        id: 22,
                        text: "Batches",
                        key: "batches",
                        path: "/teacher/batches",
                      },
                    ]
                  : []),
                ...(viewTabPermission("student")
                  ? [
                      {
                        id: 23,
                        text: "Students",
                        key: "students",
                        path: "/teacher/students",
                      },
                    ]
                  : []),
                ...(viewTabPermission("material")
                  ? [
                      {
                        id: 8,
                        text: "Materials",
                        key: "materials",
                        path: "/teacher/materials",
                      },
                    ]
                  : []),
                ...(viewTabPermission("questionbank")
                  ? [
                      {
                        id: 7,
                        text: "Question Banks",
                        key: "question_banks",
                        path: "/teacher/question_banks",
                      },
                    ]
                  : []),

                {
                  id: 3,
                  text: "Homework",
                  key: "assignment",
                  path: "/teacher/homework",
                },
                {
                  id: 11,
                  text: "Profile",
                  key: "profile",
                  path: "/teacher/profile",
                },
              ]
            : [],
    [currentPath],
  );

  useEffect(() => {
    const p = location.pathname;
    if (p.startsWith("/admin/profile")) setActivePage("profile");
    else if (p.startsWith("/admin/courses") || p.startsWith("/admin/course"))
      setActivePage("courses");
    // else if (p.startsWith("/admin/eval")) setActivePage("eval");
    else if (p.startsWith("/admin/materials")) setActivePage("materials");
    else if (p.startsWith("/admin/institution")) setActivePage("institution");
    else if (p.startsWith("/admin/initial-test")) setActivePage("initial_test");
    else if (p.startsWith("/admin/question-bank"))
      setActivePage("question_bank");
    else if (p.startsWith("/admin/reports")) setActivePage("reports");
    else if (p.startsWith("/admin/dashboard")) setActivePage("dashboard");
    else if (p.startsWith("/admin/preference")) setActivePage("preference");
    else if (p.startsWith("/admin/iq_test")) setActivePage("iq_test");
    else if (p.startsWith("/admin/models")) setActivePage("models");
    else if (p.startsWith("/admin/ai-configuration")) setActivePage("prompts");
    else if (p.startsWith("/admin/image-upload")) setActivePage("image_upload");
    else if (p.startsWith("/admin/image-folders"))
      setActivePage("image_upload");
    else if (p.startsWith("/institution/profile")) setActivePage("profile");
    else if (p.startsWith("/institution/materials")) setActivePage("materials");
    else if (p.startsWith("/institution/reports")) setActivePage("reports");
    else if (p.startsWith("/institution/dashboard")) setActivePage("dashboard");
    else if (
      p.startsWith("/institution/courses") ||
      p.startsWith("/institution/course/")
    )
      setActivePage("courses");
    else if (p.startsWith("/institution/batches/info") && role === "teacher")
      setActivePage("courses");
    else if (p.startsWith("/institution/batches")) setActivePage("batches");
    else if (p.startsWith("/institution/teachers")) setActivePage("teachers");
    else if (p.startsWith("/institution/students")) setActivePage("students");
    else if (p.startsWith("/institution/question_banks"))
      setActivePage("question_banks");
    else if (p.startsWith("/teacher/profile")) setActivePage("profile");
    else if (p.startsWith("/teacher/dashboard")) setActivePage("dashboard");
    else if (p.startsWith("/teacher/course/homework/"))
      setActivePage("assignment");
    else if (
      p.startsWith("/teacher/course-content") ||
      p.startsWith("/teacher/course/")
    )
      setActivePage("course-content");
    else if (p.startsWith("/teacher/courses")) setActivePage("courses");
    else if (p.startsWith("/teacher/batches")) setActivePage("batches");
    else if (p.startsWith("/teacher/students")) setActivePage("students");
    else if (p.startsWith("/teacher/homework")) setActivePage("assignment");
    else if (p.startsWith("/teacher/materials")) setActivePage("materials");
    else if (p.startsWith("/teacher/question_banks"))
      setActivePage("question_banks");
    else if (p.startsWith("/teacher/videos")) setActivePage("videos");
  }, [location.pathname, role]);

  const isControlled = typeof collapsedProp === "boolean";
  const collapsed = isControlled ? collapsedProp : internalCollapsed;

  const toggleCollapsed = () => {
    if (typeof onToggleCollapse === "function") {
      onToggleCollapse();
    } else {
      setInternalCollapsed((c) => !c);
    }
  };

  const isMobileControlled = typeof mobileMenuOpen === "boolean";
  const isMenuOpen = isMobileControlled ? mobileMenuOpen : internalMenuOpen;

  // const toggleMenu = () => {
  //   if (typeof onToggleMobileMenu === "function") {
  //     onToggleMobileMenu();
  //   } else {
  //     setInternalMenuOpen((o) => !o);
  //   }
  // };

  const closeMenu = () => {
    if (isMobileControlled) {
      if (isMenuOpen && typeof onToggleMobileMenu === "function") {
        onToggleMobileMenu();
      }
    } else {
      setInternalMenuOpen(false);
    }
  };

  return (
    <nav className={`navbar ${collapsed ? "collapsed" : ""}`}>
      <div className="navbar-container">
        <div className={`navbar-brand ${collapsed ? "navbar-collapse" : ""}`}>
          <Link
            to={portal === "admin" ? "/admin" : "/"}
            className="navbar-logo"
          >
            {collapsed ? (
              <img
                src={NavbarCollapseLogo}
                alt="Edlumina Logo"
                width={60}
                height={40}
              />
            ) : (
              // <span className="logo-text">Edlumina</span>
              <img
                src={EdluminaLogo}
                alt="Edlumina Logo"
                width={150}
                height={80}
              />
            )}
          </Link>
        </div>

        <div className="navbar-menu">
          {navItems.map((item) => (
            <Link
              key={item.key}
              to={item.path || "#"}
              className={`navbar-link ${
                activePage === item?.key ? "active" : ""
              }`}
              onClick={() => {
                setActivePage(item.key);
                if (item?.isNoShowHeader) {
                  setIsShowHeader(true);
                } else {
                  setIsShowHeader(false);
                }
              }}
            >
              <span className="nav-icon">
                {getIconByKey(item.key, activePage === item.key)}
              </span>
              <TooltipText
                text={item.text}
                className={`nav-text ${
                  activePage === item?.key ? "active" : ""
                }`}
                fullWidth
              />
            </Link>
          ))}
        </div>

        <div className="navbar-actions">
          <Link
            to="#"
            className="navbar-link navbar-link-logout"
            onClick={(e) => {
              e.preventDefault();
              handleLogout();
            }}
            style={{ marginBottom: "8px" }}
          >
            <span className="nav-icon">{getIconByKey("logout", false)}</span>
            <TooltipText text="Logout" className="nav-text" fullWidth />
          </Link>
          <button
            type="button"
            className={`navbar-btn ghost ${
              collapsed ? "collapse-icon-active" : ""
            }`}
            onClick={toggleCollapsed}
            title={collapsed ? "Expand" : "Collapse"}
          >
            {collapsed ? (
              <KeyboardDoubleArrowRight fontSize="small" />
            ) : (
              <>
                Collapse <KeyboardDoubleArrowLeft fontSize="small" />
              </>
            )}
          </button>
        </div>
      </div>

      <div className={`navbar-mobile ${isMenuOpen ? "open" : ""}`}>
        <div className="navbar-mobile-menu">
          <div className="navbar-mobile-header">
            <button
              className="navbar-mobile-close"
              onClick={closeMenu}
              aria-label="Close menu"
              type="button"
            >
              <CloseIcon fontSize="small" />
            </button>
          </div>
          {navItems.map((item) => (
            <a
              key={item.key}
              href="#"
              className="navbar-mobile-link"
              onClick={(e) => {
                e.preventDefault();
                if (item.path) navigate(item.path);
                setActivePage(item.key);
                closeMenu();
              }}
            >
              <span className="nav-icon">
                {getIconByKey(item.key, activePage === item.key)}
              </span>
              <TooltipText
                text={item.text}
                className={`nav-text ${
                  activePage === item?.key ? "active-page" : ""
                }`}
                fullWidth
              />
            </a>
          ))}
          <button
            type="button"
            className="navbar-mobile-link navbar-link-logout"
            onClick={() => {
              handleLogout();
              closeMenu();
            }}
          >
            <span className="nav-icon">{getIconByKey("logout", false)}</span>
            <TooltipText text="Logout" className="nav-text" fullWidth />
          </button>
        </div>
      </div>
      {isConfirmLogoutOpen && (
        <DeleteConfirmPopUp
          isConfirmDeleteOpen={isConfirmLogoutOpen}
          setIsConfirmDeleteOpen={setIsConfirmLogoutOpen}
          handleDelete={handleConfirmLogout}
          title="Logout"
          message="Are you sure you want to logout?"
          confirmLabel="Logout"
          cancelLabel="Cancel"
        />
      )}
    </nav>
  );
};

export default Navbar;
